module.exports = __webpack_public_path__ + "assets/0d1627b10fb995534242a06d902f6e9a.mp3";